import { parsedContent } from '@/lib/utils'

import luggageWalkingTravellers from '~/public/images/luggage-storage/walking-travelers.png'
import luggageShipToStorage from '~/public/images/luggage-storage/ship-to-storage.png'

import boxWalkingTravellers from '~/public/images/box-storage/walking.png'
import boxShipToStorage from '~/public/images/box-storage/ship-to-storage.png'

import golfShipToStorage from '~/public/images/golf-club-storage/ship-to-storage.png'
import golfWalkingTravellers from '~/public/images/golf-club-storage/walking-travels.png'
import golfShipToStorageBottom from '~/public/images/golf-club-storage/travel.png'
import golfWalkingTravellersBottom from '~/public/images/golf-club-storage/packing.png'

import skiShipToStorage from '~/public/images/ski-storage/ship-to-storage.png'
import skiWalkingTravellers from '~/public/images/ski-storage/walking-travelers.png'

import snowboardShipToStorage from '~/public/images/snowboard-storage/ship-to-storage.png'
import snowboardWalkingTravellers from '~/public/images/snowboard-storage/walking-travelers.png'

// const appName = Configs.APP_NAME

export const PRICING = Object.freeze({
  luggageStorage: {
    // sectionClassName: 'skip--spacing',
    header: {
      title: parsedContent(`Flexible Luggage Storage Pricing`)
    },
    content: {
      data: [
        {
          image: {
            src: luggageShipToStorage,
            alt: 'Ship To Storage'
          },
          heading: parsedContent('Ship To Storage'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Up to 6 months free storage.</li>
                     <li>Only for round trip shipment.</li>
                   </ul>           
              </div>
          `)
        },
        {
          image: {
            src: luggageWalkingTravellers,
            alt: 'Walking Travelers'
          },
          heading: parsedContent('Walking Travelers'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Drop off your luggage at our storage place!</li>
                     <li>Pay as low as $10 a day for each luggage.</li>
                   </ul>           
              </div>
          `)
        }
      ]
    }
  },
  boxStorage: {
    // sectionClassName: 'skip--spacing',
    header: {
      title: parsedContent(`Flexible Box Storage Pricing`)
    },
    content: {
      data: [
        {
          image: {
            src: boxShipToStorage,
            alt: 'Ship To Storage'
          },
          heading: parsedContent('Ship To Storage'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Up to 6 months free storage.</li>
                     <li>Only for round trip shipment.</li>
                   </ul>           
              </div>
          `)
        },
        {
          image: {
            src: boxWalkingTravellers,
            alt: 'Walking Travelers'
          },
          heading: parsedContent('Walking Travelers'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Drop off your box at our storage place!</li>
                     <li>Pay as low as $10 a day for each box.</li>
                   </ul>           
              </div>
          `)
        }
      ]
    },
    callToAction: {
      wrClassName: 'md-mn:mt-9',
      available: true,
      text: 'Book Now'
    }
  },
  golfClub: {
    // sectionClassName: 'skip--spacing',
    top: {
      header: {
        title: parsedContent(`Flexible Golf Club Storage Pricing`)
      },
      content: {
        data: [
          {
            image: {
              src: golfShipToStorage,
              alt: 'Ship To Storage'
            },
            heading: parsedContent('Ship To Storage'),
            subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Up to 6 months free storage.</li>
                     <li>Only for round trip shipment.</li>
                   </ul>           
              </div>
          `)
          },
          {
            image: {
              src: golfWalkingTravellers,
              alt: 'Walking Travelers'
            },
            heading: parsedContent('Walking Travelers'),
            subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Drop off your golf club at our storage place!</li>
                     <li>Pay as low as $10 a day for each golf club.</li>
                   </ul>           
              </div>
          `)
          }
        ]
      },
      callToAction: {
        wrClassName: 'md-mn:mt-9',
        available: true,
        text: 'Book Now'
      }
    },
    bottom: {
      header: {
        title: parsedContent(`Protecting Your Golf Clubs During Travel`),
        subtitle: parsedContent(
          `When traveling with golf clubs, taking the necessary precautions to protect them is vital to ensure they arrive at your destination in optimal condition.`,
          'max-w-[840px]'
        )
      },
      content: {
        descriptionWrClass: 'lg-mn:gap-10',
        data: [
          {
            className: 'bg-transparent',
            image: {
              src: golfShipToStorageBottom,
              alt: 'Ship To Storage',
              className: 'rounded-lg border-[2px] border-transparent hover:border-blue-500'
            },
            heading: parsedContent('Choosing The Right Travel Case', 'max-w-full'),
            subheading: parsedContent(
              `Investing in a durable and well-padded travel case can provide essential protection for golf clubs during transit. Hard cases offer maximum protection, while soft cases are lighter and more convenient for frequent travelers.`
            )
          },
          {
            className: 'bg-transparent',
            image: {
              src: golfWalkingTravellersBottom,
              alt: 'Walking Travelers',
              className: 'rounded-lg border-[2px] border-transparent hover:border-blue-500'
            },
            heading: parsedContent('Packing and Securing Clubs For Travel', 'max-w-full'),
            subheading: parsedContent(
              `When packing clubs in a travel case, ensure they are securely fastened and protected from shifting during transport. Utilizing towels or club head covers can provide additional cushioning and protection.`
            )
          }
        ]
      },
      callToAction: {
        wrClassName: 'md-mn:mt-9',
        available: true,
        text: 'Get Started'
      }
    }
  },
  skiStorage: {
    // sectionClassName: 'skip--spacing',
    header: {
      title: parsedContent(`Flexible Ski Storage Pricing`)
    },
    content: {
      data: [
        {
          image: {
            src: skiShipToStorage,
            alt: 'Ship To Storage'
          },
          heading: parsedContent('Ship To Storage'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Up to 6 months free storage.</li>
                     <li>Only for round trip shipment.</li>
                   </ul>           
              </div>
          `)
        },
        {
          image: {
            src: skiWalkingTravellers,
            alt: 'Walking Travelers'
          },
          heading: parsedContent('Walking Travelers'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Drop off your ski at our storage place!</li>
                     <li>Pay as low as $10 a day for each ski.</li>
                   </ul>           
              </div>
          `)
        }
      ]
    }
  },
  snowboardStorage: {
    // sectionClassName: 'skip--spacing',
    header: {
      title: parsedContent(`Flexible Snowboard Storage Pricing`)
    },
    content: {
      data: [
        {
          image: {
            src: snowboardShipToStorage,
            alt: 'Ship To Storage'
          },
          heading: parsedContent('Ship To Storage'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Up to 6 months free storage.</li>
                     <li>Only for round trip shipment.</li>
                   </ul>           
              </div>
          `)
        },
        {
          image: {
            src: snowboardWalkingTravellers,
            alt: 'Walking Travelers'
          },
          heading: parsedContent('Walking Travelers'),
          subheading: parsedContent(`
              <div class="flex justify-center">
                   <ul>
                     <li>Drop off your snowboard at our storage place!</li>
                     <li>Pay as low as $10 a day for each snowboard.</li>
                   </ul>           
              </div>
          `)
        }
      ]
    },
    callToAction: {
      available: true,
      text: 'Book Now'
    }
  }
})
